import { Component } from 'shimmer'

import { polarToCartesian, cartesianToPolar, clamp } from '@/utils/Maths'
import { Vector3 } from 'three'

const PI_HALF = Math.PI * .5

export class CameraControl extends Component {
  constructor (camera, container, maxPolar = PI_HALF, maxAzimuth = Math.PI) {
    super()

    this.getPointerPosition = this.getPointerPosition.bind(this)
    this.onPointerdown = this.onPointerdown.bind(this)
    this.onPointerup = this.onPointerup.bind(this)
    this.onPointermove = this.onPointermove.bind(this)

    this.camera = camera
    this.isActive = false
    this.container = container
    this.isPointerdown = false
    this.maxPolar = maxPolar
    this.maxAzimuth = maxAzimuth

    this.cursorPosition = {x: 0, y: 0}
  }

  onInit () {
    // const delta = this.camera.position.clone().sub(this.camera.look)
    const delta = new Vector3()
    delta.subVectors(this.camera.position, this.camera.look)
    this.basePolar = cartesianToPolar(delta.x, delta.y, delta.z)
    this.polar = {...this.basePolar}
    this.currentPolar = {...this.polar}
  }

  set active (isActive) {
    this.isActive = isActive
    this.onInit()
  }

  get active () {
    return this.isActive
  }

  set container (el) {
    if (this.el !== void 0) {
      this.el.removeEventListener('pointerdown', this.onPointerdown)
      this.el.removeEventListener('pointerup', this.onPointerup)
      this.el.removeEventListener('pointermove', this.onPointermove)
    }

    this.el = el

    if(el !== void 0) {
      this.el.addEventListener('pointerdown', this.onPointerdown)
      this.el.addEventListener('pointerup', this.onPointerup)
      this.el.addEventListener('pointermove', this.onPointermove)
    }
  }

  get container () {
    return this.el
  }

  onPointerdown (event) {
    this.isPointerdown = true
    this.cursorPosition = this.getPointerPosition(event)
  }

  onPointerup (event) {
    this.isPointerdown = false
  }

  onPointermove (event) {
    if (!this.isPointerdown) {return}

    const cursorPosition = this.getPointerPosition(event)
    const deltaPosition = {
      x: this.cursorPosition.x - cursorPosition.x,
      y: this.cursorPosition.y - cursorPosition.y
    }

    const newPolar = this.polar.polar + (-deltaPosition.x * 0.0025)
    const newAzimuth = this.polar.azimuth + deltaPosition.y * 0.0025

    if (Math.abs(this.basePolar.polar - newPolar) < this.maxPolar) {
      this.polar.polar = newPolar
    }
    if (Math.abs(this.basePolar.azimuth - newAzimuth) < this.maxAzimuth) {
      this.polar.azimuth = newAzimuth
    }

    this.cursorPosition = cursorPosition
    // this.polar.polar = this.polar.polar
    // this.polar.azimuth = this.polar.azimuth
  }

  onUpdate () {
    if (!this.isActive) {return}

    this.currentPolar.polar += (this.polar.polar - this.currentPolar.polar) * 0.1
    this.currentPolar.azimuth += (this.polar.azimuth - this.currentPolar.azimuth) * 0.1

    const position = polarToCartesian(this.currentPolar.radius, this.currentPolar.polar, this.currentPolar.azimuth)

    this.camera.position.x = position.x + this.camera.look.x
    this.camera.position.y = position.y + this.camera.look.y
    this.camera.position.z = position.z + this.camera.look.z

    this.camera.lookAt(this.camera.look.x, this.camera.look.y, this.camera.look.z) // Check forceupdate
    // this.camera.look.set(this.camera.look.x, this.camera.look.y, this.camera.look.z)
  }

  // setDistance (distance) {
  //   this.distance = distance
  // }

  getPointerPosition (event) {
    let clientY = event.clientY
    let clientX = event.clientX

    return {
      x: clientX,
      y: clientY
    }
  }
}